const statuses = [
    {'value': 'in_active', 'label': 'Inactive', 'variation': 'subdued'},
    {'value': 'deleted', 'label': 'Deleted', 'variation': 'negative'},
    {'value': 'active', 'label': 'Active', 'variation': 'positive'},
]

export default statuses
